import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatUrl } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class ObNewsItem extends React.PureComponent {
    static propTypes = {
        cityObservation: PropTypes.array,
        index: PropTypes.number,
    };

    static defaultProps = {
        cityObservation: [],
    };

    render() {
        const { cityObservation, index } = this.props;

        return (
            <div className={styles.newsItem}>
                <h1>
                    <a href={formatUrl(cityObservation[index].url)} target="_blank" title="" rel={rel}>
                        {cityObservation[index].title}
                    </a>
                </h1>
                <div className={styles.zz}>
                    <span>
                        来源：<b>{cityObservation[index].source ? cityObservation[index].source : ''}</b>
                    </span>
                    <span>
                        时间：<b>{cityObservation[index].newsTime}</b>
                    </span>
                    <p>{cityObservation[index].summary}</p>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ObNewsItem);
